import { Injectable } from '@angular/core';
import { ConfigDataProvider } from '../config-data/config-data';

@Injectable()
export class PermissionsProvider {

	constructor(
		private configDataPrvdr: ConfigDataProvider
	) {

	}

	public hasPermission(permission): Boolean {

		let permissionsList: Array<any> = this.configDataPrvdr.getPermissions();
		
		let hasPermission: Boolean = false;

		if (permissionsList && permissionsList.length > 0) {

			permissionsList.forEach((tmpPermission) => {
				if (tmpPermission == permission) {
					hasPermission = true;
				}
			});

		} else {
			hasPermission = false;
		}

		return hasPermission;

	}
}



// WEBPACK FOOTER //
// ./src/providers/permissions/permissions.ts